import CounterInput from '@/atoms/forms/Counter';
import Spinner from '@/atoms/loader/Spinner';
import CardThumb from '@/molecules/CardThumb';
import ModalClassicLayout from 'context/Modal/layout/Classic';
import { FormProvider } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { SIZE, VARIANT_COLOR_ENUM } from 'types/utils';
import useAddCardToPageModal from './hook';
import AlertTool from '@/molecules/AlertTool';
import CustomMarkdown from '@/molecules/CustomMarkdown';

type Props = {
  printingPage: string;
  cardId: string;
  closeModal: () => void;
};

const AddCardToPage = ({ printingPage, cardId, closeModal }: Props) => {
  const { formMethods, handleSubmit, card } = useAddCardToPageModal({ printingPage, cardId, closeModal });
  const { t } = useTranslation();

  return (
    <ModalClassicLayout
      closeModal={closeModal}
      isLoading={formMethods.formState.isSubmitting}
      onSubmit={handleSubmit}
      submitLabel={t('add-card')}
      title="add-card"
    >
      {card && card.stats?.isExclusive && !!card.stats?.numberCopyAvailable && (
        <AlertTool icon="fa-solid fa-circle-info" variant={VARIANT_COLOR_ENUM.INFO}>
          <CustomMarkdown className="p-0">{t('alert.exclusiveWarn')}</CustomMarkdown>
        </AlertTool>
      )}
      {card && card.stats?.isExclusive && !card.stats?.numberCopyAvailable && (
        <AlertTool icon="fa-solid fa-circle-info" variant={VARIANT_COLOR_ENUM.INFO}>
          <CustomMarkdown className="p-0">{t('alert.exclusiveError')}</CustomMarkdown>
        </AlertTool>
      )}
      <FormProvider {...formMethods}>
        <form className="mt-4" onSubmit={handleSubmit}>
          {!card && <Spinner size={SIZE.MD} />}
          <div className="max-w-72 mx-auto">
            <CardThumb
              alt=""
              className="mb-4"
              imagePath={card?.imagePath || ''}
              inMyCollection={card.stats?.inMyCollection}
              inMySale={card.stats?.inMySale || 0}
              isExclusive={!!card.stats?.isExclusive}
              isSuspended={card.isSuspended}
              numberCopyAvailable={card.stats?.numberCopyAvailable}
            />
            <CounterInput className="px-2" label="quantity" max={20} name="quantity" />
          </div>
          <input className="hidden" type="submit" />
        </form>
      </FormProvider>
    </ModalClassicLayout>
  );
};

export default AddCardToPage;
